interface CustomProps {
  heading: string;
  subInfo: string;
}

const CustomPageHeader = (props: CustomProps) => {
  return (
    <div className="mb-4">
      <h1 className="font-yh-bold text-xl text-yh-blue-2 md:text-2xl">
        {props.heading}
      </h1>
      {props.subInfo && (
        <p className="mt-1 text-sm text-yh-secondary-text">{props.subInfo}</p>
      )}
    </div>
  );
};

export default CustomPageHeader;
